<template>
  <div id="app-div" style="overflow-y: hidden">
    <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../../assets/u3220.png" class="icon_img" />
          筛选查询
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="6">
            <label>稿件编号：</label>
            <a-input
              placeholder="请输入"
              v-model="queryCode"
              class="query_input"
            />
          </a-col>
          <a-col :span="6">
            <label>标题：</label>
            <a-input
              placeholder="请输入"
              v-model="queryCnTitle"
              class="query_input"
            />
          </a-col>
          <a-col :span="6">
            <label>作者：</label>
            <a-input
              placeholder="请输入"
              v-model="queryAuthorName"
              class="query_input"
            />
          </a-col>
          <a-button type="primary" class="query_btn" @click="query">
            查询
          </a-button>
        </a-row>
      </div>
    </div>
    <div class="middle">
      <div style="float: left; margin-left: 10px">
        <img src="../../../../assets/u3227.png" class="icon_img" />
        <span>&nbsp;数据列表</span>
      </div>
      <div class="sortType" style="float: right">
        排序方式：
        <a-select
          size="small"
          defaultValue="1"
          style="width: 120px"
          @change="sortChange"
          v-model="sort"
        >
          <a-select-option value="1">编号降序</a-select-option>
          <a-select-option value="2">编号升序</a-select-option>
          <a-select-option value="3">时间降序</a-select-option>
          <a-select-option value="4">时间升序</a-select-option>
        </a-select>
      </div>
    </div>
    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :rowSelection="rowSelection"
          :columns="columns"
          :dataSource="data"
          :rowKey="(record) => record.code"
          size="small"
          :scroll="{ y: data.length < 8 ? false : table_height }"
          bordered
        >
          <span slot="operator" slot-scope="text, record">
            <a href="javascript:void(0);" @click="() => manage(record)">
              发表建议设置
            </a>
          </span>
          <template slot="sort" slot-scope="text, record, index">
            {{ `${(page - 1) * limit + index + 1}` }}
          </template>
          <span slot="code" slot-scope="text, record">
            <label @click="manuscriptsInfo(record)" class="view_manu">{{
              record.code
            }}</label>
          </span>
          <span slot="suggestion" slot-scope="text, record">
            {{
              record.suggestion
                ? `${record.suggestion.year}年总第${record.suggestion.planCount}期 ${record.suggestion.sectionInfo} ${record.suggestion.columnName}`
                : "--"
            }}
          </span>
          <span slot="cnTitle" slot-scope="text, record">
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ record.cnTitle }}</span>
              </template>
              <div class="shenglue">
                <label @click="preview(record)" class="view_manu">{{
                  record.cnTitle
                }}</label>
              </div>
            </a-tooltip>
          </span>
        </a-table>
      </div>
      <div id="components-pagination-demo-mini">
        <a-pagination
          :total="total"
          :showTotal="(total) => `共 ${total} 条`"
          showSizeChanger
          showQuickJumper
          :pageSizeOptions="pageSizeOptions"
          :defaultPageSize="limit"
          @showSizeChange="onShowSizeChange"
          @change="pageChange"
        />
      </div>
      <a-select
        defaultValue="0"
        class="batch_operation"
        @change="operateChange"
        v-model="operateCode"
      >
        <a-select-option value="0">批量操作</a-select-option>
        <a-select-option value="1">批量导出</a-select-option>
        <a-select-option value="2">批量下载</a-select-option>
      </a-select>
    </div>

    <a-modal
      title="发表建议"
      v-model="suggestVisible"
      width="70%"
      @ok="handleSuggestOk"
      @cancel="closeSuggest"
      :destroyOnClose="true"
      :maskClosable="false"
    >
      <a-row class="su-row">
        <a-col :span="4" class="title"> 年份：</a-col>
        <a-col :span="14">
          <a-select
            style="width: 100%"
            v-model="suggestInfo.suggestYear"
            @change="getPublishPlan"
          >
            <a-select-option v-for="item in yearList" :key="item" :value="item">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row class="su-row">
        <a-col :span="4" class="title"> 建议期次：</a-col>
        <a-col :span="14">
          <a-select style="width: 100%" v-model="suggestInfo.suggestPlan">
            <a-select-option
              v-for="item in planList"
              :key="item.total"
              :value="item.total"
            >
              {{ `总第${item.total}期` }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row class="su-row">
        <a-col :span="4" class="title"> 版本：</a-col>
        <a-col :span="14">
          <a-select
            style="width: 100%"
            v-model="suggestInfo.sectionInfo"
            @change="onSectionInfoChange"
          >
            <a-select-option
              v-for="item in sectionInfos"
              :value="item.dicValue"
              :key="item.dicValue"
            >
              {{ item.dicValue }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row class="su-row">
        <a-col :span="4" class="title"> 建议栏目：</a-col>
        <a-col :span="14">
          <a-select style="width: 100%" v-model="suggestInfo.suggestColumn">
            <a-select-option
              v-for="item in columnList"
              :key="item.columnCode"
              :value="item.columnCode"
            >
              {{ item.columnName }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
    </a-modal>

    <ManuscriptInfo ref="manuscriptInfo" :infoData="manuscript" />
  </div>
</template>


<script>
const columns = [
  {
    title: "序号",
    dataIndex: "sort",
    width: 60,
    scopedSlots: { customRender: "sort" },
  },
  {
    title: "稿件编号",
    dataIndex: "code",
    width: 110,
    scopedSlots: { customRender: "code" },
  },
  {
    title: "标题",
    dataIndex: "cnTitle",
    scopedSlots: { customRender: "cnTitle" },
  },
  {
    title: "学科",
    dataIndex: "discipline",
  },
  {
    title: "作者",
    width: 80,
    dataIndex: "authorName",
  },
  {
    title: "所在单位",
    dataIndex: "companyName",
  },
  {
    title: "版本",
    width: 130,
    dataIndex: "sectionInfo",
  },
  {
    title: "栏目",
    dataIndex: "columnInfo",
  },
  {
    title: "稿件字数",
    width: 90,
    dataIndex: "wordCount",
  },
  {
    title: "备注",
    dataIndex: "note",
  },
  {
    title: "发表建议",
    dataIndex: "suggestion",
    scopedSlots: { customRender: "suggestion" },
  },
  {
    title: "操作",
    width: 140,
    key: "action",
    scopedSlots: { customRender: "operator" },
  },
];

import qs from "qs";
import ManuscriptInfo from "../../../commomon/ManuscriptInfo.vue";
export default {
  name: "MyManuscripts",
  props: {
    pageType: {
      type: Number,
      default: 0,
    },
  },
  components: {
    ManuscriptInfo,
  },
  data() {
    return {
      serviceAddress: this.$config.serviceAddress,
      manuscript: {},
      data: [],
      columns,
      selectedRowKeys: [],
      queryCode: "",
      queryCnTitle: "",
      queryAuthorName: "",
      queryEditorName: "",
      sort: "1",
      sortField: "code",
      sortType: "desc",
      operateCode: "0",
      page: 1,
      limit: 20,
      total: 0,
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      table_height: 0,
      suggestVisible: false,
      yearList: [],
      planList: [],
      columnList: [],
      sectionInfos: [],
      suggestInfo: {
        code: "",
        suggestYear: "",
        suggestPlan: "",
        suggestColumn: "",
        sectionInfo: "",
        suggestId: 0,
      },
    };
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        columnWidth: 35,
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        onSelection: this.onSelection,
        getCheckboxProps: (record) => ({
          props: {
            disabled: this.pageType == 1,
          },
        }),
      };
    },
  },
  created() {
    this.query();
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 230;
    var bottom = document.getElementById("bottom");
    bottom.style.height = bottom_height + "px";
    this.table_height = bottom_height - 100;

    if (this.pageType == 1) {
      this.suggestInfo.suggestYear = new Date().getFullYear().toString();
      this.axios.get("/publishPlan/queryYear").then((res) => {
        this.yearList = res.data;
      });
      this.axios
        .get("/dataDic/queryChild", { params: { parentCode: "section_info" } })
        .then((res) => {
          if (res.data) {
            this.sectionInfos = res.data;
          } else {
            this.utils.messageInfo(this, "error", "查询刊物版本失败！");
          }
        });
      this.getPublishPlan();
    }
  },
  methods: {
    //预览稿件
    preview(record) {
      var codes = [];
      codes.push(record.code);
      this.axios
        .post("/manuscriptsAddFile/queryByCode", {
          codes: JSON.stringify(codes),
        })
        .then((res) => {
          if (res.data.code == "OK") {
            var addFile = res.data.data;
            if (addFile.length > 0) {
              this.$router.push({
                path: "/edit/preview",
                query: { fileCode: addFile[0].code },
              });
            } else {
              this.utils.messageInfo(this, "error", "稿件不存在！");
            }
          } else {
            this.utils.messageInfo(this, "error", "查询稿件失败！");
          }
        });
    },
    manuscriptsInfo(record) {
      this.manuscript = record;
      this.$refs.manuscriptInfo.show();
    },
    manage(record) {
      if (this.pageType == 0) {
        this.$router.push({
          path: "/backManager",
          query: {
            code: record.code,
          },
        });
      } else if (this.pageType == 1) {
        this.suggestInfo.code = record.code;
        this.suggestInfo.sectionInfo = record.sectionInfo;
        this.getColumnList(this.suggestInfo.sectionInfo);
        this.axios
          .get("/manuscripts/getManuscriptsSuggestion", {
            params: { code: record.code },
            paramsSerializer: function (p) {
              return qs.stringify(p, { arrayFormat: "repeat" });
            },
          })
          .then((res) => {
            if (res.data.code == "OK" && res.data.data) {
              this.suggestInfo.suggestId = res.data.data.id;
              this.suggestInfo.suggestYear = res.data.data.year;
              this.suggestInfo.suggestPlan = res.data.data.planCount;
              this.suggestInfo.suggestColumn = res.data.data.columnCode;
              this.suggestInfo.sectionInfo = res.data.data.sectionInfo;
              this.getColumnList(this.suggestInfo.sectionInfo);
            }
          });
        this.suggestVisible = true;
      }
    },
    onShowSizeChange(current, pageSize) {
      this.page = current;
      this.limit = pageSize;
      this.query();
    },
    pageChange(pageNumber) {
      this.page = pageNumber;
      this.query();
    },
    sortChange() {
      if (this.sort == 1) {
        this.sortField = "code";
        this.sortType = "desc";
      } else if (this.sort == 2) {
        this.sortField = "code";
        this.sortType = "";
      } else if (this.sort == 3) {
        this.sortField = "create_time";
        this.sortType = "desc";
      } else if (this.sort == 4) {
        this.sortField = "create_time";
        this.sortType = "";
      }
      this.query();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    operateChange() {
      var itemLegth = this.selectedRowKeys.length;
      if (itemLegth == 0) {
        this.utils.messageInfo(this, "error", "最少选择一条数据！");
        return;
      }
      if (this.operateCode == "1") {
        if (this.serviceAddress == "") {
          this.utils.messageInfo(
            this,
            "error",
            "获取后台ip地址失败，无法导出！"
          );
          return;
        }
        var selectedRowKeys = this.selectedRowKeys;
        window.open(
          this.serviceAddress +
            "/manuscripts/exportData?codeArr=" +
            selectedRowKeys +
            "&type=2"
        );
      } else if (this.operateCode == "2") {
        //批量下载
        window.open(
          this.serviceAddress +
            "/manuscripts/downLoadBatch?codes=" +
            this.selectedRowKeys.join() +
            "&preview=true&zipName=预览稿件"
        );
      }
      this.operateCode = "0";
    },
    query() {
      if (this.pageType == 0) {
        this.axios
          .get("/manuscripts/myManuscripts", {
            params: {
              code: this.queryCode,
              cnTitle: this.queryCnTitle,
              authorName: this.queryAuthorName,
              status: 2,
              auditStatus: 11,
              sortField: this.sortField,
              sortType: this.sortType,
              userCode: sessionStorage.getItem("userCode"),
              page: this.page,
              limit: this.limit,
              suggest: 1, // 查询发表建议
              time: new Date().getTime(),
            },
            paramsSerializer: function (p) {
              return qs.stringify(p, { arrayFormat: "repeat" });
            },
          })
          .then((res) => {
            if (res.data.code == "0") {
              this.total = res.data.count;
              this.data = res.data.data;
            } else {
              this.utils.messageInfo(this, "error", "查询稿件列表失败！");
            }
          });
      } else if (this.pageType == 1) {
        this.axios
          .get("/manuscripts/queryQuery", {
            params: {
              code: this.queryCode,
              cnTitle: this.queryCnTitle,
              authorName: this.queryAuthorName,
              status: 2,
              auditStatus: 11,
              sortField: this.sortField,
              sortType: this.sortType,
              page: this.page,
              limit: this.limit,
              suggest: 1,
              time: new Date().getTime(),
            },
            paramsSerializer: function (p) {
              return qs.stringify(p, { arrayFormat: "repeat" });
            },
          })
          .then((res) => {
            if (res.data.code == "0") {
              this.total = res.data.count;
              this.data = res.data.data;
            } else {
              this.utils.messageInfo(this, "error", "查询稿件列表失败！");
            }
          });
      }
    },
    onSectionInfoChange(val) {
      this.suggestInfo.sectionInfo = val;
      this.getColumnList(val);
    },
    getColumnList(sectionInfo) {
      this.axios
        .get("/columnInfo/queryColumnInfo", {
          params: {
            sortField: "create_time",
            sortType: "asc",
            sectionInfo: sectionInfo,
            page: 1,
            limit: 100,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.columnList = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询栏目列表失败！");
          }
        });
    },
    getPublishPlan() {
      this.axios
        .get("/publishPlan/queryPublishPlan", {
          params: {
            year: this.suggestInfo.suggestYear,
            sortField: "total",
            sortType: "asc",
            page: 1,
            limit: 100,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.planList = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询出版计划列表失败！");
          }
        });
    },
    handleSuggestOk() {
      if (this.suggestInfo.suggestYear == "") {
        this.utils.messageInfo(this, "error", "请选择年份！");
        return;
      }
      if (this.suggestInfo.suggestPlan == "") {
        this.utils.messageInfo(this, "error", "请选择建议期次！");
        return;
      }
      if (this.suggestInfo.sectionInfo == "") {
        this.utils.messageInfo(this, "error", "请选择版本！");
        return;
      }
      if (this.suggestInfo.suggestColumn == "") {
        this.utils.messageInfo(this, "error", "请选择建议栏目！");
        return;
      }
      if (this.suggestInfo.suggestId > 0) {
        this.axios
          .post("/manuscripts/updateManuscriptsSuggestion", {
            id: this.suggestInfo.suggestId,
            code: this.suggestInfo.code,
            year: this.suggestInfo.suggestYear,
            planCount: this.suggestInfo.suggestPlan,
            columnCode: this.suggestInfo.suggestColumn,
            sectionInfo: this.suggestInfo.sectionInfo,
            createUser: sessionStorage.getItem("userCode"),
          })
          .then((res) => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "保存成功！");
              this.suggestInfo = {
                code: "",
                suggestYear: "",
                suggestPlan: "",
                suggestColumn: "",
                sectionInfo: "",
                suggestId: 0,
              };
              this.suggestVisible = false;
              this.query();
            } else {
              this.utils.messageInfo(this, "error", "保存失败！");
            }
          });
      } else {
        this.axios
          .post("/manuscripts/saveManuscriptsSuggestion", {
            code: this.suggestInfo.code,
            year: this.suggestInfo.suggestYear,
            planCount: this.suggestInfo.suggestPlan,
            columnCode: this.suggestInfo.suggestColumn,
            sectionInfo: this.suggestInfo.sectionInfo,
            createUser: sessionStorage.getItem("userCode"),
          })
          .then((res) => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "保存成功！");
              this.suggestInfo = {
                code: "",
                suggestYear: "",
                suggestPlan: "",
                suggestColumn: "",
                sectionInfo: "",
                suggestId: 0,
              };
              this.suggestVisible = false;
              this.query();
            } else {
              this.utils.messageInfo(this, "error", "保存失败！");
            }
          });
      }
    },
    closeSuggest() {
      this.suggestInfo = {
        code: "",
        suggestYear: "",
        suggestPlan: "",
        suggestColumn: "",
        sectionInfo: "",
        suggestId: 0,
      };
      this.suggestVisible = false;
    },
  },
};
</script>
<style>
@import "../../../../assets/css/PageCss.css";
</style>
<style scoped>
.su-row {
  margin-top: 10px;
}
.su-row .title {
  text-align: right;
  height: 32px;
  line-height: 32px;
  padding-right: 10px;
}
</style>
